import { environmentVariable, resolveEnvironmentVariable } from '@/lib/env';

export const BASE_URL_WEBSITE = resolveEnvironmentVariable(environmentVariable.WEBSITE_URL);
export const IMPRINT_URL = `${BASE_URL_WEBSITE}/imprint`;
export const PRIVACY_URL = `${BASE_URL_WEBSITE}/privacy-policy`;
export const TERMS_URL = `${BASE_URL_WEBSITE}/terms-of-service`;
